export default [
  {
    path: '/merchantCouponActivities', name: 'merchantCouponActivities', component: () => import('@/pages/coupon/merchantCouponActivities'), meta: { title: '优惠券活动' },
  },
  {
    path: '/addCouponActivities', name: 'addCouponActivities', component: () => import('@/pages/coupon/addCouponActivities'), meta: { title: '新建' },
  },
  {
    path: '/merchantCouponDetailed', name: 'merchantCouponDetailed', component: () => import('@/pages/coupon/merchantCouponDetailed'), meta: { title: '优惠券明细' },
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/coupon.js